// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

export const globalStore = new Vue({
  data: {
    utilisateur: {
      "nom": "Comptable",
      "type": "administrateur"
    },
    test: "OK",
    enModification: false
  }
})


Vue.prototype.$globals = globalStore


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js